import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

export const startDateResolver: ResolveFn<Date | undefined> = (
  route: ActivatedRouteSnapshot,
) => {
  const startDateMsRaw = route.queryParamMap.get('startDateMs');

  if (!startDateMsRaw) {
    return undefined;
  }

  const startDateMs = Number(startDateMsRaw);

  return Number.isFinite(startDateMs) ? new Date(startDateMs) : undefined;
};
